var map = {
	"./de/settings/index.js": [
		86344,
		7340
	],
	"./en/settings/index.js": [
		90464
	],
	"./es/settings/index.js": [
		25023,
		3705
	],
	"./fr/settings/index.js": [
		44855,
		9697
	],
	"./it/settings/index.js": [
		36973,
		9406
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 87720;
module.exports = webpackAsyncContext;